import Vue from 'vue';

Vue.directive('auto-resize', el => {
  Vue.nextTick(() => {
    const element = el;
    element.style.minHeight = '40px';
    element.style.overflowY = 'hidden';
    if (element.value === '') {
      element.style.height = el.style.minHeight;
      el.BodyScrollHeight = 38;
    }

    if (element.scrollHeight > 25) {
      element.style.height = `${el.scrollHeight}px`;
    }
  });
});



// WEBPACK FOOTER //
// ./src/includes/vue-directives.js